<header class="main-header">
  <a (click)="navigationClick('dashboard')" class="logo">
    <span class="logo-lg">
      <!-- <img class="full-logo img-responsive" alt="Logo" [src]="logoName" /> -->
      @if (defaultlogo) {
        <img class="full-logo-default img-responsive" />
      }
      @if (!defaultlogo) {
        <img class="full-logo img-responsive" [src]="logoName" />
      }
    </span>
  </a>

  <nav class="navbar navbar-static-top">
    <a class="sidebar-toggle" data-toggle="offcanvas" role="button" title="Menu" (click)="resizeStatisticsChart()">
      <span class="sr-only">Toggle navigation</span>
    </a>

    <label class="powered-by">{{ poweredBy }}</label>

    <div class="header-bind col-xs-12" [class.emulated]="isUserEmulated()">
      @if (!isContextSwitching) {
        <span style="cursor: default"
          ><b style="margin-right: 3px; font-weight: lighter; cursor: default">Corporation:</b>
          {{ configuration.CorporationName }}</span
        >
        <span style="cursor: default"
          ><b style="margin-right: 3px; font-weight: lighter; cursor: default">Venue:</b>
          {{ configuration.VenueName }}</span
        >
        <span style="cursor: default"
          ><b style="margin-right: 3px; font-weight: lighter; cursor: default">Alert Type:</b>
          {{ configuration.AlertTypeName }}</span
        >
      } @else {
        <span class="context-loading" title="Updating venue context">Updating context...</span>
      }
    </div>
    <div class="navbar-custom-menu">
      @if (isUserEmulated()) {
        <div></div>
      }
      <ul class="nav navbar-nav">
        <li class="dropdown user user-menu">
          <a class="dropdown-toggle" data-toggle="dropdown" aria-expanded="true">
            <span class="hidden-xs">{{ userName }}</span>
            @if (isUserEmulated()) {
              <span class="current-user-info pull-right">
                <i class="fa fa-user user-icon" aria-hidden="true"></i> Currently logged in as:
                <p>{{ emulatedUserName }}</p>
              </span>
            }
            <img [src]="profileImgSrc != null ? profileImgSrc : profileImg" class="user-image" alt="Profile" />
          </a>
          <ul class="dropdown-menu col-md-12 col-lg-12 col-xs-12">
            <li class="user-profile-dropdown col-md-12 col-lg-12 col-xs-12">
              <div class="userProfile col-md-12 col-lg-12 col-xs-12">
                @if (currentUserVal.ContextRoleId == null || currentUserVal.ContextRoleId == 0) {
                  <a class="role-name">{{ currentUserVal.UserRole.RoleName }}</a>
                }
                @if (currentUserVal.ContextRoleId != null || currentUserVal.ContextRoleId > 0) {
                  <a class="role-name">{{ currentUserVal.ContextRoleName }}</a>
                }
              </div>

              @if (TraxPermission.PROFILE_MENU | canAccess: userPermissions) {
                <div class="userProfile col-md-12 col-lg-12 col-xs-12" (click)="navigationClick('profile-menu')">
                  <a class="profileName"><i class="fa fa-id-badge"></i>Profile</a>
                </div>
              }

              <div class="userProfile col-md-12 col-lg-12 col-xs-12" (click)="configurationPopup()">
                <a class="profileName"> <i class="fa fa-cog"></i>Configuration</a>
              </div>
              @if (isUserEmulated()) {
                <div class="userProfile col-md-12 col-lg-12 col-xs-12" (click)="stopEmulation()">
                  <a class="profileName"> <i class="fa fa-sign-out"></i>End Emulation</a>
                </div>
              }
              <div class="userProfile col-md-12 col-lg-12 col-xs-12" (click)="logout()">
                <a class="profileName"> <i class="fa fa-sign-out"></i>Sign Out</a>
              </div>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </nav>
</header>

<aside class="main-sidebar" id="main-sidebar">
  <section class="sidebar" id="sidebar">
    <ul class="sidebar-menu tree" data-widget="tree">
      @if (TraxPermission.DASHBOARD | canAccess: userPermissions) {
        <li class="treeview" [routerLink]="'dashboard'" [routerLinkActive]="['active']" (click)="navSlide()">
          <a (click)="navigationClick('dashboard')">
            <i class="fa fa-tachometer"></i><span>Dashboard</span>
            <div class="triangle-left"></div>
          </a>
        </li>
      }

      @if (TraxPermission.OVERVIEW_DASHBOARD | canAccess: userPermissions) {
        <li class="treeview" [routerLinkActive]="['active']" (click)="navSlide()">
          <a (click)="navigationClick('overview-dashboard')" style="padding: 4px">
            <svg
              id="dashboard_copy"
              data-name="dashboard copy"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 512 512"
            >
              <rect x="324.1" y="329.27" width="150.35" height="147.2" fill="#5b5f60" />
              <rect x="40.27" y="329.27" width="150.35" height="147.2" fill="#5b5f60" />
              <rect x="324.1" y="36.36" width="150.35" height="147.2" fill="#5b5f60" />
              <rect x="179.27" y="95.97" width="150.35" height="27.99" fill="#5b5f60" />
              <rect x="179.27" y="388.88" width="150.35" height="27.99" fill="#5b5f60" />
              <rect
                x="324.1"
                y="244.13"
                width="150.35"
                height="27.99"
                transform="translate(657.4 -141.15) rotate(90)"
                fill="#5b5f60"
              />
              <rect
                x="40.27"
                y="244.13"
                width="150.35"
                height="27.99"
                transform="translate(373.57 142.68) rotate(90)"
                fill="#5b5f60"
              />
              <rect x="40.27" y="36.36" width="150.35" height="147.2" fill="#5b5f60" />
            </svg>
            <span class="restroomOvr">Inspection Overview</span>
            <div class="triangle-left"></div>
          </a>
        </li>
      }

      @if (TraxPermission.INSPECTION_DASHBOARD | canAccess: userPermissions) {
        <li class="treeview" [routerLinkActive]="['active']" (click)="navSlide()">
          <a style="padding: 4px" (click)="navigationClick('inspection-dashboard')">
            <svg xmlns="http://www.w3.org/2000/svg" id="Dashboard" viewBox="0 0 512 512">
              <rect x="31" y="38" width="228" height="228" fill="#0e2c44" />
              <rect x="321" y="116" width="156" height="150" fill="#0e2c44" />
              <rect x="321" y="330" width="156" height="150" fill="#0e2c44" />
              <rect x="103" y="330" width="156" height="150" fill="#0e2c44" />
            </svg>
            <span class="restroomOvr">Inspection Dashboard</span>
            <div class="triangle-left"></div>
          </a>
        </li>
      }

      <!--<li class="treeview" *ngIf="(TraxPermission.INSPECTION_STATISTICS | canAccess: userPermissions)" [routerLinkActive]="['active']" (click)="navSlide()">
                <a (click)="navigationClick('inspection-statistics')">
                  <i class="fa fa-line-chart" aria-hidden="true" style="font-size: 20px;"></i>
                  <span style="margin: 0 0 0 2px;">Inspection Statistics</span>
                  <div class="triangle-left"></div>
                </a>
              </li>-->

      @if (TraxPermission.CALENDAR | canAccess: userPermissions) {
        <li class="treeview" [routerLinkActive]="['active']" (click)="navSlide()">
          <a (click)="navigationClick('calendar')">
            <i class="fa fa-calendar"></i><span>Calendar</span>
            <div class="triangle-left"></div>
          </a>
        </li>
      }

      @if (TraxPermission.RESTROOM_OVERVIEW | canAccess: userPermissions) {
        <li class="treeview" [routerLinkActive]="['active']" (click)="navSlide()">
          <a (click)="navigationClick('restroom-overview')" style="padding: 4px">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 489.48 497.2">
              <path d="M51.28,54.75c4.25-75.45,108.08-70.51,110.07,0C157.1,130.19,53.28,125.25,51.28,54.75Z" />
              <path d="M330.78,54.75c4.26-75.45,108.08-70.51,110.08,0C436.6,130.19,332.78,125.25,330.78,54.75Z" />
              <rect x="243.22" y="9.42" width="12.95" height="487.78" />
              <path
                d="M334.11,191S316.76,266.16,311,284.86,277.44,299,280.67,273.25s12.89-96,12.89-96,2.58-61.88,41.9-61.24,93.46,0,93.46,0,29.65-5.15,40.61,30.94S482.27,231,488.87,267.45c5.14,28.35-23.72,37.46-32.87,5.8-4.66-16.11-13.6-82.91-13.6-82.91h-3.93L438,460.19c-.82,29.9-38.08,31.11-40.61,3.22l.7-152-20.69-.18c-1.3,130.82,9.1,170.29-16.65,172.71-29.61-.83-20.61-30.78-22.62-53.38-2.75-116.3-2.76-162.56-1.57-239.75h.59Z"
              />
              <path
                d="M53.7,191s-17.34,75.18-23.14,93.88S-3,299,.26,273.25s12.89-96,12.89-96,2.58-61.88,41.9-61.24,93.47,0,93.47,0,29.65-5.15,40.61,30.94S201.86,231,208.46,267.45c5.14,28.35-23.72,37.46-32.87,5.8-4.66-16.11-13.6-82.91-13.6-82.91h-3.92l-.53,269.85c-.82,29.9-38.07,31.11-40.61,3.22l.71-152L97,311.28C95.65,442.1,106.05,481.57,80.3,484c-29.62-.83-20.62-30.78-22.63-53.38-2.74-116.3-2.76-162.56-1.56-239.75h.59Z"
              />
              <polygon points="58.79 212.2 153.35 212.2 174.82 349.58 36.9 349.58 58.79 212.2" />
            </svg>
            <span class="restroomOvr">Location Overview</span>
            <div class="triangle-left"></div>
          </a>
        </li>
      }

      @if (
        (TraxPermission.SERVICE_PROVIDER | canAccess: userPermissions) ||
        (TraxPermission.SERVICE_PROVIDER_VIEW | canAccess: userPermissions) ||
        (TraxPermission.SERVICE_PROVIDER_EDIT | canAccess: userPermissions)
      ) {
        <li id="service-provider-config" class="treeview" [routerLinkActive]="['active']">
          <a>
            <img src="assets/icons/service_provider_menu_icon.svg" alt="Service Provider" /><span class="sp_icon">
              Service Provider Mgmt</span
            >
            <span class="pull-right-container">
              <i class="fa fa-caret-left fa-angle-left"></i>
            </span>
          </a>
          <ul class="treeview-menu">
            <li [routerLinkActive]="['active']" (click)="navSlide()">
              <a (click)="navigationClick('task')" [routerLink]="['/task']">
                <span><b>&#x25CF;&nbsp;</b> Tasks</span>
                <div class="triangle-left"></div>
              </a>
            </li>
            <li [routerLinkActive]="['active']" (click)="navSlide()">
              <a (click)="navigationClick('inventory')" [routerLink]="['/inventory']">
                <span><b>&#x25CF;&nbsp;</b> Inventories</span>
                <div class="triangle-left"></div>
              </a>
            </li>
            <li [routerLinkActive]="['active']" (click)="navSlide()">
              <a (click)="navigationClick('element')" [routerLink]="['/element']">
                <span><b>&#x25CF;&nbsp;</b> Elements</span>
                <div class="triangle-left"></div>
              </a>
            </li>
          </ul>
        </li>
      }

      @if (
        (TraxPermission.PROFILE_MENU | canAccess: userPermissions) ||
        (TraxPermission.USER | canAccess: userPermissions) ||
        (TraxPermission.USER_ROLE_PERMISSION_TEMPLATE | canAccess: userPermissions) ||
        (TraxPermission.ROLE | canAccess: userPermissions) ||
        (TraxPermission.DEVICE_REGISTRATION | canAccess: userPermissions) ||
        (TraxPermission.SHARE_USER | canAccess: userPermissions) ||
        (TraxPermission.ACQUIRED_USERS | canAccess: userPermissions) ||
        (TraxPermission.TRANSFER_OWNERSHIP | canAccess: userPermissions) ||
        (TraxPermission.SUBSCRIPTION | canAccess: userPermissions) ||
        isSysAdmin
      ) {
        <li class="treeview menu-open" [routerLinkActive]="['active']">
          <a>
            <i class="fa fa-user"></i><span>User Management</span>
            <span class="pull-right-container">
              <i class="fa fa-caret-left fa-angle-left"></i>
            </span>
          </a>
          <ul class="treeview-menu">
            @if (TraxPermission.PROFILE_MENU | canAccess: userPermissions) {
              <li [routerLinkActive]="['active']" (click)="navSlide()">
                <a (click)="navigationClick('profile-menu')" [routerLink]="['/profile-menu']">
                  <span><b>&#x25CF;&nbsp;</b> My Profile</span>
                  <div class="triangle-left"></div>
                </a>
              </li>
            }
            @if (TraxPermission.USER_ROLE_PERMISSION_TEMPLATE | canAccess: userPermissions) {
              <li [routerLinkActive]="['active']" (click)="navSlide()">
                <a
                  (click)="navigationClick('user-role-permission-template')"
                  [routerLink]="['/user-role-permission-template']"
                >
                  <span><b>&#x25CF;&nbsp;</b> User Role Templates</span>
                  <div class="triangle-left"></div>
                </a>
              </li>
            }
            @if (TraxPermission.ROLE | canAccess: userPermissions) {
              <li [routerLinkActive]="['active']" (click)="navSlide()">
                <a (click)="navigationClick('role')" [routerLink]="['/role']">
                  <span><b>&#x25CF;&nbsp;</b> User Roles</span>
                  <div class="triangle-left"></div>
                </a>
              </li>
            }
            @if (TraxPermission.USER | canAccess: userPermissions) {
              <li [routerLinkActive]="['active']" (click)="navSlide()">
                <a (click)="navigationClick('user')" [routerLink]="['/user']">
                  <span><b>&#x25CF;&nbsp;</b> Users</span>
                  <div class="triangle-left"></div>
                </a>
              </li>
            }
            @if (TraxPermission.DEVICE_REGISTRATION | canAccess: userPermissions) {
              <li [routerLinkActive]="['active']" (click)="navSlide()">
                <a (click)="navigationClick('device-registration')" [routerLink]="['/device-registration']">
                  <span><b>&#x25CF;&nbsp;</b> Device Information</span>
                  <div class="triangle-left"></div>
                </a>
              </li>
            }
            @if (isSysAdmin) {
              <li [routerLinkActive]="['active']" (click)="navSlide()">
                <a (click)="navigationClick('subscription')" [routerLink]="['/subscription']">
                  <span><b>&#x25CF;&nbsp;</b> Subscriptions</span>
                  <div class="triangle-left"></div>
                </a>
              </li>
            }
            @if (TraxPermission.USER_LICENSE_REQUEST_LOG | canAccess: userPermissions) {
              <li [routerLinkActive]="['active']" (click)="navSlide()">
                <a (click)="navigationClick('user-license-request-log')" [routerLink]="['/user-license-request-log']">
                  <span><b>&#x25CF;&nbsp;</b> User License Request Log</span>
                  <div class="triangle-left"></div>
                </a>
              </li>
            }
            @if ((TraxPermission.SHARE_USER | canAccess: userPermissions) && isAllowToShareUserShow) {
              <li [routerLinkActive]="['active']" (click)="navSlide()">
                <a [routerLink]="['/share-user']">
                  <span><b>&#x25CF;&nbsp;</b> Share Users</span>
                  <div class="triangle-left"></div>
                </a>
              </li>
            }
            @if (TraxPermission.ACQUIRED_USERS | canAccess: userPermissions) {
              <li [routerLinkActive]="['active']" (click)="navSlide()">
                <a [routerLink]="['/acquired-users']">
                  <span><b>&#x25CF;&nbsp;</b> Acquire Users</span>
                  <div class="triangle-left"></div>
                </a>
              </li>
            }
            @if (TraxPermission.TRANSFER_OWNERSHIP | canAccess: userPermissions) {
              <li [routerLinkActive]="['active']" (click)="navSlide()">
                <a [routerLink]="['/transfer-ownership']">
                  <span><b>&#x25CF;&nbsp;</b> Transfer Ownership</span>
                  <div class="triangle-left"></div>
                </a>
              </li>
            }
          </ul>
        </li>
      }

      @if (
        (TraxPermission.LOCATION_GROUP | canAccess: userPermissions) ||
        ((TraxPermission.USERLOCATIONASSIGNMENT | canAccess: userPermissions) &&
          (isLocationUserAssignmentShow || isEitherOneOrTheseShow)) ||
        (TraxPermission.INSPECTORLOCATIONASSIGNMENT | canAccess: userPermissions)
      ) {
      <li class="treeview" [routerLinkActive]="['active']">
        <a>
          <img class="location-group-icon" src="assets/icons/location-group.svg" alt="" aria-hidden="true" />
          <span>Location Assignment</span>
          <span class="pull-right-container">
            <i class="fa fa-caret-left fa-angle-left"></i>
          </span>
        </a>
        <ul class="treeview-menu">
        @if (TraxPermission.LOCATION_GROUP | canAccess: userPermissions) {
            <li [routerLinkActive]="['active']" (click)="navSlide()">
              <a (click)="navigationClick('location-group')" [routerLink]="['/location-group']">
                <span><b>&#x25CF;&nbsp;</b> Location Groups</span>
                <div class="triangle-left"></div>
              </a>
            </li>
         }
          @if (
            (TraxPermission.USERLOCATIONASSIGNMENT | canAccess: userPermissions) &&
            (isLocationUserAssignmentShow || isEitherOneOrTheseShow)
          ) {
            <li [routerLinkActive]="['active']" (click)="navSlide()">
              <a [routerLink]="['/userlocationassignment']">
                <span><b>&#x25CF;&nbsp;</b> Assign Alerts/QC Locations</span>
                <div class="triangle-left"></div>
              </a>
            </li>
          }
          @if (TraxPermission.INSPECTORLOCATIONASSIGNMENT | canAccess: userPermissions) {
            <li [routerLinkActive]="['active']" (click)="navSlide()">
              <a
                (click)="navigationClick('inspectorlocationassignment')"
                [routerLink]="['/inspectorlocationassignment']"
              >
                <span><b>&#x25CF;&nbsp;</b> Assign Inspection Locations</span>
                <div class="triangle-left"></div>
              </a>
            </li>
          }
        </ul>
      </li>
      }

      @if (
        (TraxPermission.SERVICE_PROVIDER | canAccess: userPermissions) ||
        (TraxPermission.CORPORATION | canAccess: userPermissions) ||
        (TraxPermission.VENUE | canAccess: userPermissions) ||
        ((TraxPermission.AREA | canAccess: userPermissions) && utilitiesService.isAreaMenuShow) ||
        (TraxPermission.BUILDING | canAccess: userPermissions) ||
        (TraxPermission.ZONE | canAccess: userPermissions) ||
        (TraxPermission.BEACON | canAccess: userPermissions) ||
        (TraxPermission.LEVEL_ASSIGNMENT | canAccess: userPermissions) ||
        (TraxPermission.LOCATION_TYPE | canAccess: userPermissions) ||
        (TraxPermission.LOCATION_TEMPLATE | canAccess: userPermissions) ||
        (TraxPermission.LOCATION | canAccess: userPermissions) ||
        (TraxPermission.BADGE | canAccess: userPermissions) ||
        (TraxPermission.GATEWAY | canAccess: userPermissions) ||
        (TraxPermission.GATE | canAccess: userPermissions) ||
        (TraxPermission.LOCATION_GATE_GROUP | canAccess: userPermissions) ||
        isSysAdmin
      ) {
        <li class="treeview" [routerLinkActive]="['active']">
          <a>
            <i class="fa fa-building"></i><span>Facilities</span>
            <span class="pull-right-container">
              <i class="fa fa-caret-left fa-angle-left"></i>
            </span>
          </a>
          <ul class="treeview-menu facilities-menu">
            @if (TraxPermission.SERVICE_PROVIDER | canAccess: userPermissions) {
              <li [routerLinkActive]="['active']" (click)="navSlide()">
                <a (click)="navigationClick('service-provider')" [routerLink]="['/service-provider']">
                  <span><b>&#x25CF;&nbsp;</b> Service Providers</span>
                  <div class="triangle-left"></div>
                </a>
              </li>
            }
            @if (TraxPermission.CORPORATION | canAccess: userPermissions) {
              <li [routerLinkActive]="['active']" (click)="navSlide()">
                <a (click)="navigationClick('corporation')" [routerLink]="['/corporation']">
                  <span><b>&#x25CF;&nbsp;</b> Corporations</span>
                  <div class="triangle-left"></div>
                </a>
              </li>
            }
            @if (TraxPermission.VENUE | canAccess: userPermissions) {
              <li [routerLinkActive]="['active']" (click)="navSlide()">
                <a (click)="navigationClick('venue')" [routerLink]="['/venue']">
                  <span><b>&#x25CF;&nbsp;</b> Venues</span>
                  <div class="triangle-left"></div>
                </a>
              </li>
            }
            @if ((TraxPermission.AREA | canAccess: userPermissions) && utilitiesService.isAreaMenuShow) {
              <li [routerLinkActive]="['active']" (click)="navSlide()">
                <a (click)="navigationClick('area')" [routerLink]="['/area']">
                  <span><b>&#x25CF;&nbsp;</b> Areas</span>
                  <div class="triangle-left"></div>
                </a>
              </li>
            }
            @if (TraxPermission.BUILDING | canAccess: userPermissions) {
              <li [routerLinkActive]="['active']" (click)="navSlide()">
                <a (click)="navigationClick('building')" [routerLink]="['/building']">
                  <span><b>&#x25CF;&nbsp;</b> Buildings</span>
                  <div class="triangle-left"></div>
                </a>
              </li>
            }
            @if (TraxPermission.ZONE | canAccess: userPermissions) {
              <li [routerLinkActive]="['active']" (click)="navSlide()">
                <a (click)="navigationClick('zone')" [routerLink]="['/zone']">
                  <span><b>&#x25CF;&nbsp;</b> Zones</span>
                  <div class="triangle-left"></div>
                </a>
              </li>
            }
            @if (TraxPermission.BEACON | canAccess: userPermissions) {
              <li [routerLinkActive]="['active']" (click)="navSlide()">
                <a (click)="navigationClick('beacon')" [routerLink]="['/beacon']">
                  <span><b>&#x25CF;&nbsp;</b> Beacons</span>
                  <div class="triangle-left"></div>
                </a>
              </li>
            }
            @if (TraxPermission.LEVEL_ASSIGNMENT | canAccess: userPermissions) {
              <li [routerLinkActive]="['active']" (click)="navSlide()">
                <a (click)="navigationClick('level-assignment')" [routerLink]="['/level-assignment']">
                  <span><b>&#x25CF;&nbsp;</b> Level Assignments</span>
                  <div class="triangle-left"></div>
                </a>
              </li>
            }
            @if (TraxPermission.LOCATION_TYPE | canAccess: userPermissions) {
              <li [routerLinkActive]="['active']" (click)="navSlide()">
                <a (click)="navigationClick('location-type')" [routerLink]="['/location-type']">
                  <span><b>&#x25CF;&nbsp;</b> Location Types</span>
                  <div class="triangle-left"></div>
                </a>
              </li>
            }
            @if (TraxPermission.LOCATION_TEMPLATE | canAccess: userPermissions) {
              <li [routerLinkActive]="['active']" (click)="navSlide()">
                <a (click)="navigationClick('location-template')" [routerLink]="['/location-template']">
                  <span><b>&#x25CF;&nbsp;</b> Location Templates</span>
                  <div class="triangle-left"></div>
                </a>
              </li>
            }
            @if (TraxPermission.LOCATION | canAccess: userPermissions) {
              <li [routerLinkActive]="['active']" (click)="navSlide()">
                <a (click)="navigationClick('location')" [routerLink]="['/location']">
                  <span><b>&#x25CF;&nbsp;</b> Locations</span>
                  <div class="triangle-left"></div>
                </a>
              </li>
            }
            @if (TraxPermission.BADGE | canAccess: userPermissions) {
              <li [routerLinkActive]="['active']" (click)="navSlide()">
                <a (click)="navigationClick('badge')" [routerLink]="['/badge']">
                  <span><b>&#x25CF;&nbsp;</b> Badges</span>
                  <div class="triangle-left"></div>
                </a>
              </li>
            }
            @if (TraxPermission.GATEWAY | canAccess: userPermissions) {
              <li [routerLinkActive]="['active']" (click)="navSlide()">
                <a (click)="navigationClick('gateway')" [routerLink]="['/gateway']">
                  <span><b>&#x25CF;&nbsp;</b> Gateways</span>
                  <div class="triangle-left"></div>
                </a>
              </li>
            }
            @if (TraxPermission.GATE | canAccess: userPermissions) {
              <li [routerLinkActive]="['active']" (click)="navSlide()">
                <a (click)="navigationClick('gate')" [routerLink]="['/gate']">
                  <span><b>&#x25CF;&nbsp;</b> Gates</span>
                  <div class="triangle-left"></div>
                </a>
              </li>
            }
            @if (TraxPermission.LOCATION_GATE_GROUP | canAccess: userPermissions) {
              <li [routerLinkActive]="['active']" (click)="navSlide()">
                <a (click)="navigationClick('location-gate-group')" [routerLink]="['/location-gate-group']">
                  <span><b>&#x25CF;&nbsp;</b> Location Gate Groups</span>
                  <div class="triangle-left"></div>
                </a>
              </li>
            }
            @if (isSysAdmin) {
              <li [routerLinkActive]="['active']" (click)="navSlide()">
                <a (click)="navigationClick('country')" [routerLink]="['/country']">
                  <span><b>&#x25CF;&nbsp;</b> Countries</span>
                  <div class="triangle-left"></div>
                </a>
              </li>
            }
            @if (isSysAdmin) {
              <li [routerLinkActive]="['active']" (click)="navSlide()">
                <a (click)="navigationClick('state')" [routerLink]="['/state']">
                  <span><b>&#x25CF;&nbsp;</b> States</span>
                  <div class="triangle-left"></div>
                </a>
              </li>
            }
            @if (isSysAdmin) {
              <li [routerLinkActive]="['active']" (click)="navSlide()">
                <a (click)="navigationClick('city')" [routerLink]="['/city']">
                  <span><b>&#x25CF;&nbsp;</b> Cities</span>
                  <div class="triangle-left"></div>
                </a>
              </li>
            }
          </ul>
        </li>
      }

      @if (TraxPermission.STALL_OCCUPANCY_STATUS | canAccess: userPermissions) {
        <li class="treeview" [routerLinkActive]="['active']" (click)="navSlide()">
          <a (click)="navigationClick('stall-occupancy-status')" [routerLink]="['/stall-occupancy-status']">
            <i class="fa fa-adjust"></i><span>Stall Occupancy Status</span>
            <div class="triangle-left"></div>
          </a>
        </li>
      }

      @if (
        ((TraxPermission.SHIFT | canAccess: userPermissions) ||
          (TraxPermission.SHIFT_BREAK_SCHEDULE | canAccess: userPermissions) ||
          (TraxPermission.STAFF_SCHEDULE | canAccess: userPermissions)) &&
        (isShiftStaffScheduleShow || isEitherOneOrTheseShow)
      ) {
        <li id="staffSchedule" class="treeview" [routerLinkActive]="['active']">
          <a>
            <i class="fa fa-clock-o"></i><span>Schedule</span>
            <span class="pull-right-container">
              <i class="fa fa-caret-left fa-angle-left"></i>
            </span>
          </a>
          <ul class="treeview-menu">
            @if (TraxPermission.SHIFT | canAccess: userPermissions) {
              <li [routerLinkActive]="['active']" (click)="navSlide()">
                <a (click)="navigationClick('shift')" [routerLink]="['/shift']">
                  <span><b>&#x25CF;&nbsp;</b> Shifts</span>
                  <div class="triangle-left"></div>
                </a>
              </li>
            }
            @if (TraxPermission.SHIFT_BREAK_SCHEDULE | canAccess: userPermissions) {
              <li [routerLinkActive]="['active']" (click)="navSlide()">
                <a (click)="navigationClick('shift-break-schedule')" [routerLink]="['/shift-break-schedule']">
                  <span><b>&#x25CF;&nbsp;</b> Shift Break Schedules</span>
                  <div class="triangle-left"></div>
                </a>
              </li>
            }
            @if (TraxPermission.STAFF_SCHEDULE | canAccess: userPermissions) {
              <li [routerLinkActive]="['active']" (click)="navSlide()">
                <a (click)="navigationClick('staff-schedule')" [routerLink]="['/staff-schedule']">
                  <span><b>&#x25CF;&nbsp;</b> Staff Schedules</span>
                  <div class="triangle-left"></div>
                </a>
              </li>
            }
          </ul>
        </li>
      }

      @if (
        ((TraxPermission.FEEDBACK_CONFIGURATION | canAccess: userPermissions) ||
          (TraxPermission.VENUE_FEEDBACK_REASON | canAccess: userPermissions)) &&
        isTouchlessFeedbackShow
      ) {
        <li id="touchlessfeedback" class="treeview" [routerLinkActive]="['active']">
          <a style="padding: 4px; display: none">
            <svg id="touchlessfeedback" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
              <rect x="114.01" y="17.64" width="282.54" height="433.93" rx="31.82" fill="#152735" />
              <rect
                id="touchlessfeedback-rect"
                x="127.93"
                y="38.86"
                width="254.69"
                height="351"
                rx="20.87"
                fill="#0E2C45"
              />
              <circle cx="255.27" cy="425.37" r="16.41" fill="#0E2C45" />
              <polygon points="132.97 440.48 209.74 495.6 195.22 442.83 132.97 440.48" fill="#152735" />
            </svg>
            <span class="restroomOvr"> Touchless Feedback</span>
            <span class="pull-right-container">
              <i class="fa fa-caret-left fa-angle-left"></i>
            </span>
          </a>
          <ul class="treeview-menu">
            @if (TraxPermission.FEEDBACK_CONFIGURATION | canAccess: userPermissions) {
              <li [routerLinkActive]="['active']" (click)="navSlide()">
                <a (click)="navigationClick('feedback-configuration')" [routerLink]="['/feedback-configuration']">
                  <span><b>&#x25CF;&nbsp;</b> Feedback Configuration</span>
                  <div class="triangle-left"></div>
                </a>
              </li>
            }
            @if ((TraxPermission.VENUE_FEEDBACK_REASON | canAccess: userPermissions) && isTouchlessFeedbackReasonShow) {
              <li [routerLinkActive]="['active']" (click)="navSlide()">
                <a (click)="navigationClick('venue-feedback-reason')" [routerLink]="['/venue-feedback-reason']">
                  <span><b>&#x25CF;&nbsp;</b> Feedback Reasons</span>
                  <div class="triangle-left"></div>
                </a>
              </li>
            }
          </ul>
        </li>
      }

      @if (isSysAdmin) {
        <li class="treeview" [routerLinkActive]="['active']">
          <a>
            <i class="fa fa-cog"></i><span>Venue Survey Config</span>
            <span class="pull-right-container">
              <i class="fa fa-caret-left fa-angle-left"></i>
            </span>
          </a>
          <ul class="treeview-menu">
            @if (isSysAdmin) {
              <li [routerLinkActive]="['active']" (click)="navSlide()">
                <a
                  (click)="navigationClick('survey-question-configuration')"
                  [routerLink]="['/survey-question-configuration']"
                >
                  <span><b>&#x25CF;&nbsp;</b> Survey Questions</span>
                  <div class="triangle-left"></div>
                </a>
              </li>
            }
            @if (isSysAdmin) {
              <li [routerLinkActive]="['active']" (click)="navSlide()">
                <a
                  (click)="navigationClick('survey-question-response-configuration')"
                  [routerLink]="['/survey-question-response-configuration']"
                >
                  <span><b>&#x25CF;&nbsp;</b> Survey Qn Responses</span>
                  <div class="triangle-left"></div>
                </a>
              </li>
            }
          </ul>
        </li>
      }

      @if ((TraxPermission.CLEANING_ALERT | canAccess: userPermissions) || isSysAdmin) {
        <li class="treeview" [routerLinkActive]="['active']">
          <a style="padding: 4px; display: none">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M10.631 5.68602C8.21399 8.47702 4.97499 10.661 2.26599 11.891C1.83599 12.078 1.49899 12.43 1.33099 12.868C1.16199 13.31 1.17899 13.802 1.37899 14.231C1.78999 15.119 2.40899 16.447 2.82399 17.337C3.02599 17.768 3.39399 18.099 3.84399 18.253C4.28999 18.405 4.77899 18.371 5.19899 18.159C7.87499 16.863 11.634 15.81 15.324 15.749L10.631 5.68602ZM11.673 4.37002L17 15.793C17.301 15.814 17.6 15.843 17.897 15.88C18.539 15.977 19.172 15.721 19.557 15.212C19.945 14.698 20.018 14.012 19.746 13.428C18.585 10.912 16.438 6.30702 15.264 3.78902C14.989 3.20102 14.412 2.81302 13.764 2.78202C13.122 2.75002 12.514 3.07402 12.182 3.62202C12.02 3.87502 11.85 4.12502 11.673 4.37002Z"
                fill="white"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M19.412 8.54299L21.224 7.69799C21.599 7.52299 21.762 7.07599 21.587 6.70099C21.412 6.32599 20.965 6.16299 20.59 6.33799L18.778 7.18299C18.402 7.35799 18.24 7.80499 18.415 8.17999C18.59 8.55499 19.036 8.71799 19.412 8.54299Z"
                fill="white"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M19.864 11.951L21.743 12.635C22.132 12.777 22.563 12.576 22.705 12.187C22.846 11.798 22.645 11.367 22.257 11.226L20.377 10.542C19.988 10.4 19.557 10.601 19.416 10.99C19.274 11.379 19.475 11.81 19.864 11.951Z"
                fill="white"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M17.867 5.159L18.551 3.28C18.693 2.891 18.492 2.46 18.103 2.318C17.714 2.177 17.283 2.378 17.142 2.767L16.458 4.646C16.316 5.035 16.517 5.466 16.906 5.607C17.295 5.749 17.725 5.548 17.867 5.159Z"
                fill="white"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M11.561 17.143C10.179 17.404 8.85 17.776 7.646 18.214L8.813 20.716C9.222 21.592 10.263 21.971 11.139 21.563C11.288 21.493 11.443 21.421 11.592 21.351C12.013 21.155 12.338 20.8 12.497 20.364C12.656 19.928 12.635 19.446 12.438 19.026L11.561 17.143Z"
                fill="white"
              />
            </svg>
            <span class="restroomOvr"> Alerts</span>
            <span class="pull-right-container">
              <i class="fa fa-caret-left fa-angle-left"></i>
            </span>
          </a>
          <ul class="treeview-menu">
            @if ('cleaning-alert' | canAccess: userPermissions) {
              <li [routerLinkActive]="['active']" (click)="navSlide()">
                <a (click)="navigationClick('cleaning-alert/list')" [routerLink]="['/cleaning-alert/list']">
                  <span><b>&#x25CF;&nbsp;</b> Alert Logs</span>
                  <div class="triangle-left"></div>
                </a>
              </li>
            }
          </ul>
        </li>
      }

      @if (TraxPermission.QUALITY_CHECK_LOG | canAccess: userPermissions) {
        <li class="treeview" (click)="navSlide()">
          <a (click)="navigationClick('quality-check-log')" style="padding: 4px; display: none">
            <svg
              enable-background="new 0 0 79.707 79.707"
              version="1.1"
              viewBox="0 0 79.707 79.707"
              xml:space="preserve"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="m67.239 79.707-8.41-28.273c-0.207-7.525-4.795-13.963-11.309-16.849v-26.918c0-4.228-3.439-7.667-7.667-7.667-4.227 0-7.666 3.439-7.666 7.667v26.918c-6.513 2.886-11.099 9.323-11.306 16.844l-8.413 28.275h54.771v3e-3zm-12.81-6-3.431-12.806c-0.287-1.065-1.377-1.704-2.449-1.413-1.067 0.284-1.7 1.381-1.414 2.448l3.152 11.771h-8.436v-12.29c0-1.104-0.896-2-2-2s-2 0.896-2 2v12.287h-7.435l3.153-11.771c0.286-1.065-0.347-2.164-1.414-2.449-1.068-0.289-2.164 0.349-2.449 1.414l-3.431 12.806h-5.765l5.579-18.75h0.012 27.5 0.015l5.575 18.75h-4.763l1e-3 3e-3zm-16.242-66.04c0-0.919 0.748-1.667 1.666-1.667 0.919 0 1.667 0.748 1.667 1.667v25.373c-0.55-0.048-1.104-0.084-1.666-0.084s-1.117 0.036-1.667 0.084v-25.373zm1.667 31.289c6.135 0 11.275 4.276 12.637 10h-25.274c1.36-5.725 6.503-10 12.637-10z"
              />
            </svg>
            <span class="restroomOvr">Quality Check Logs</span>
            <div class="triangle-left"></div>
          </a>
        </li>
      }

      @if (
        (TraxPermission.ASSET | canAccess: userPermissions) ||
        (TraxPermission.ASSET_TYPE | canAccess: userPermissions) ||
        (TraxPermission.PRODUCT | canAccess: userPermissions) ||
        (TraxPermission.PRODUCT_MODEL | canAccess: userPermissions) ||
        (TraxPermission.PRODUCT_MANUFACTURER | canAccess: userPermissions) ||
        (TraxPermission.SUPPLIER | canAccess: userPermissions)
      ) {
        <li class="treeview" [routerLinkActive]="['active']">
          <a>
            <i class="fa fa-book fa-2"></i><span>Asset Management</span>
            <span class="pull-right-container">
              <i class="fa fa-caret-left fa-angle-left"></i>
            </span>
          </a>
          <ul class="treeview-menu asset-menu">
            @if (TraxPermission.SUPPLIER | canAccess: userPermissions) {
              <li [routerLinkActive]="['active']" (click)="navSlide()">
                <a (click)="navigationClick('supplier')" [routerLink]="['/supplier']">
                  <span><b>&#x25CF;&nbsp;</b> Suppliers</span>
                  <div class="triangle-left"></div>
                </a>
              </li>
            }
            @if (TraxPermission.PRODUCT_MANUFACTURER | canAccess: userPermissions) {
              <li [routerLinkActive]="['active']" (click)="navSlide()">
                <a (click)="navigationClick('product-manufacturer')" [routerLink]="['/product-manufacturer']">
                  <span><b>&#x25CF;&nbsp;</b> Product Manufacturers</span>
                  <div class="triangle-left"></div>
                </a>
              </li>
            }
            @if (TraxPermission.PRODUCT_MODEL | canAccess: userPermissions) {
              <li [routerLinkActive]="['active']" (click)="navSlide()">
                <a (click)="navigationClick('product-model')" [routerLink]="['/product-model']">
                  <span><b>&#x25CF;&nbsp;</b> Product Models</span>
                  <div class="triangle-left"></div>
                </a>
              </li>
            }
            @if (TraxPermission.PRODUCT | canAccess: userPermissions) {
              <li [routerLinkActive]="['active']" (click)="navSlide()">
                <a (click)="navigationClick('product')" [routerLink]="['/product']">
                  <span><b>&#x25CF;&nbsp;</b> Products</span>
                  <div class="triangle-left"></div>
                </a>
              </li>
            }
            @if (TraxPermission.ASSET | canAccess: userPermissions) {
              <li [routerLinkActive]="['active']" (click)="navSlide()">
                <a (click)="navigationClick('asset')" [routerLink]="['/asset']">
                  <span><b>&#x25CF;&nbsp;</b> Assets</span>
                  <div class="triangle-left"></div>
                </a>
              </li>
            }
            @if (TraxPermission.ASSET_TYPE | canAccess: userPermissions) {
              <li [routerLinkActive]="['active']" (click)="navSlide()">
                <a (click)="navigationClick('asset-type')" [routerLink]="['/asset-type']">
                  <span><b>&#x25CF;&nbsp;</b> Asset Types</span>
                  <div class="triangle-left"></div>
                </a>
              </li>
            }
          </ul>
        </li>
      }

      @if (
        (TraxPermission.WORKORDER_CATEGORY | canAccess: userPermissions) ||
        (TraxPermission.WORKORDER_TYPE | canAccess: userPermissions) ||
        (TraxPermission.CLOSURE_TEMPLATE | canAccess: userPermissions) ||
        (TraxPermission.WORKORDER | canAccess: userPermissions)
      ) {
        <li class="treeview" [routerLinkActive]="['active']">
          <a style="padding: 4px; display: none">
            <svg
              class="restroomOvr1"
              enable-background="new 0 0 460 460"
              version="1.1"
              viewBox="0 0 460 460"
              xml:space="preserve"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="m393.94 0h-327.89c-15.655 0-28.346 12.691-28.346 28.346v403.31c0 15.656 12.691 28.347 28.346 28.347h327.89c15.655 0 28.346-12.691 28.346-28.346v-403.31c0-15.655-12.691-28.346-28.346-28.346zm-284.7 351.67c-15.28 0-27.667-12.387-27.667-27.667s12.387-27.667 27.667-27.667 27.667 12.387 27.667 27.667-12.387 27.667-27.667 27.667zm0-94c-15.28 0-27.667-12.387-27.667-27.667s12.387-27.667 27.667-27.667 27.667 12.387 27.667 27.667-12.387 27.667-27.667 27.667zm0-94c-15.28 0-27.667-12.387-27.667-27.667s12.387-27.667 27.667-27.667 27.667 12.387 27.667 27.667-12.387 27.667-27.667 27.667zm245.17 185.33h-170.91c-13.807 0-25-11.193-25-25s11.193-25 25-25h170.91c13.807 0 25 11.193 25 25s-11.193 25-25 25zm0-94h-170.91c-13.807 0-25-11.193-25-25s11.193-25 25-25h170.91c13.807 0 25 11.193 25 25s-11.193 25-25 25zm0-94h-170.91c-13.807 0-25-11.193-25-25s11.193-25 25-25h170.91c13.807 0 25 11.193 25 25s-11.193 25-25 25z"
              />
            </svg>
            <span class="restroomOvr">Work Order Mgmt</span>
            <span class="pull-right-container">
              <i class="fa fa-angle-left pull-right"></i>
            </span>
          </a>
          <ul class="treeview-menu">
            @if (TraxPermission.WORKORDER_CATEGORY | canAccess: userPermissions) {
              <li [routerLinkActive]="['active']" (click)="navSlide()">
                <a (click)="navigationClick('workorder-category')" [routerLink]="['/workorder-category']">
                  <span><b>&#x25CF;&nbsp;</b> Work Order Categories</span>
                  <div class="triangle-left"></div>
                </a>
              </li>
            }
            @if (TraxPermission.WORKORDER_TYPE | canAccess: userPermissions) {
              <li [routerLinkActive]="['active']" (click)="navSlide()">
                <a (click)="navigationClick('workorder-type')" [routerLink]="['/workorder-type']">
                  <span><b>&#x25CF;&nbsp;</b> Work Order Types</span>
                  <div class="triangle-left"></div>
                </a>
              </li>
            }
            @if (TraxPermission.CLOSURE_TEMPLATE | canAccess: userPermissions) {
              <li [routerLinkActive]="['active']" (click)="navSlide()">
                <a (click)="navigationClick('closure-template')" [routerLink]="['/closure-template']">
                  <span><b>&#x25CF;&nbsp;</b> Closure Templates</span>
                  <div class="triangle-left"></div>
                </a>
              </li>
            }
            @if (TraxPermission.WORKORDER | canAccess: userPermissions) {
              <li [routerLinkActive]="['active']" (click)="navSlide()">
                <a (click)="navigationClick('workorder')" [routerLink]="['/workorder']">
                  <span><b>&#x25CF;&nbsp;</b> Work Orders</span>
                  <div class="triangle-left"></div>
                </a>
              </li>
            }
          </ul>
        </li>
      }

      @if (
        (TraxPermission.INSPECTION_LOG | canAccess: userPermissions) ||
        (TraxPermission.INSPECTION | canAccess: userPermissions) ||
        (TraxPermission.VENUE_ELEMENT_CONFIGURATION | canAccess: userPermissions) ||
        (TraxPermission.INSPECTORLOCATIONASSIGNMENT | canAccess: userPermissions) ||
        (TraxPermission.LOCATION_OVERVIEW | canAccess: userPermissions) ||
        (TraxPermission.INSPECTION_NOTIFICATION_ALERT | canAccess: userPermissions) ||
        isSysAdmin
      ) {
        <li class="treeview" [routerLinkActive]="['active']">
          <a>
            <i class="fa fa-search" aria-hidden="true"></i><span>Inspections</span>
            <span class="pull-right-container">
              <i class="fa fa-angle-left pull-right"></i>
            </span>
          </a>
          <ul class="treeview-menu">
            @if (TraxPermission.INSPECTION_LOG | canAccess: userPermissions) {
              <li [routerLinkActive]="['active']" (click)="navSlide()">
                <a (click)="navigationClick('inspection-log')" [routerLink]="['/inspection-log']">
                  <span><b>&#x25CF;&nbsp;</b> Inspection Logs</span>
                  <div class="triangle-left"></div>
                </a>
              </li>
            }
            @if (isSysAdmin) {
              <li [routerLinkActive]="['active']" (click)="navSlide()">
                <a
                  (click)="navigationClick('inspection-score-factor-configuration')"
                  [routerLink]="['/inspection-score-factor-configuration']"
                >
                  <span><b>&#x25CF;&nbsp;</b> Inspection Score Factor</span>
                  <div class="triangle-left"></div>
                </a>
              </li>
            }
            @if (TraxPermission.INSPECTION | canAccess: userPermissions) {
              <li [routerLinkActive]="['active']" (click)="navSlide()">
                <a (click)="navigationClick('inspection')" [routerLink]="['/inspection']">
                  <span><b>&#x25CF;&nbsp;</b> Inspections</span>
                  <div class="triangle-left"></div>
                </a>
              </li>
            }
            @if (TraxPermission.LOCATION_OVERVIEW | canAccess: userPermissions) {
              <li [routerLinkActive]="['active']" (click)="navSlide()">
                <a (click)="navigationClick('location-overview')" [routerLink]="['/location-overview']">
                  <span><b>&#x25CF;&nbsp;</b> Inspection Locations</span>
                  <div class="triangle-left"></div>
                </a>
              </li>
            }
            @if (TraxPermission.INSPECTION_NOTIFICATION_ALERT | canAccess: userPermissions) {
              <li [routerLinkActive]="['active']" (click)="navSlide()">
                <a
                  (click)="navigationClick('inspection-notification-alert')"
                  [routerLink]="['/inspection-notification-alert']"
                >
                  <span><b>&#x25CF;&nbsp;</b> Notification Alerts</span>
                  <div class="triangle-left"></div>
                </a>
              </li>
            }
          </ul>
        </li>
      }

      @if ((TraxPermission.PROJECT_WORK_LOG | canAccess: userPermissions) || isSysAdmin) {
        <li class="treeview" [routerLinkActive]="['active']">
          <a style="padding: 4px; display: none">
            <svg id="projectWorkSVG" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
              <g>
                <rect
                  x="90"
                  y="70"
                  width="331"
                  height="394"
                  rx="4.82"
                  ry="4.82"
                  style="fill: none; stroke: #edefee; stroke-width: 30px"
                />
                <path
                  id="pwPathOne"
                  d="M184,33h141c6.62,0,12,5.38,12,12v51H172V45c0-6.62,5.38-12,12-12Z"
                  class="navigation"
                />
                <g>
                  <path
                    id="pwPathTwo"
                    d="M142.8,350s172.4,1.67,199.18-151.48"
                    style="fill: none; stroke: #edefee; stroke-width: 20px"
                  />
                  <polyline
                    points="291.97 229.15 344.11 189.11 368 255.58"
                    style="fill: none; stroke: #edefee; stroke-width: 20px"
                  />
                </g>
              </g>
            </svg>
            <span class="restroomOvr"> Project Work</span>
            <span class="pull-right-container">
              <i class="fa fa-caret-left fa-angle-left"></i>
            </span>
          </a>
          <ul class="treeview-menu">
            @if (TraxPermission.PROJECT_WORK_LOG | canAccess: userPermissions) {
              <li [routerLinkActive]="['active']" (click)="navSlide()">
                <a (click)="navigationClick('project-work-log')" [routerLink]="['/project-work-log']">
                  <span><b>&#x25CF;&nbsp;</b> Project Work Logs</span>
                  <div class="triangle-left"></div>
                </a>
              </li>
            }
          </ul>
        </li>
      }
      @if (TraxPermission.QC_CLEANING_ALERT | canAccess: userPermissions) {
        <li class="treeview" (click)="navSlide()">
          <a (click)="navigationClick('qc-cleaning-alert')" style="padding: 6px">
            <svg
              class="restroomOvr1"
              enable-background="new 0 0 218.356 218.356"
              version="1.1"
              viewBox="0 0 218.36 218.36"
              xml:space="preserve"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="m142.68 0h-91.73c-16.143 0-29.278 13.135-29.278 29.278v159.8c0 16.143 13.135 29.278 29.278 29.278h116.46c16.143 0 29.275-13.135 29.275-29.278v-128.71l-54.009-60.369zm4.208 27.525 25.179 28.141h-25.179v-28.141zm34.587 161.55c-3e-3 7.754-6.308 14.061-14.061 14.061h-116.46c-7.753 0-14.061-6.307-14.061-14.061v-159.8c0-7.753 6.307-14.061 14.061-14.061h80.722v55.667h49.803v118.19z"
              />
              <rect x="92.758" y="161.8" width="70.879" height="15.217" />
              <rect x="92.758" y="125.45" width="70.879" height="15.217" />
              <rect x="92.758" y="88.957" width="70.879" height="15.217" />
              <polygon points="61.909 96.664 56.899 91.845 49.865 99.152 62.117 110.94 79.829 92.88 72.589 85.776" />
              <polygon points="61.909 133.16 56.899 128.34 49.865 135.65 62.117 147.44 79.829 129.38 72.589 122.27" />
              <polygon points="61.909 169.51 56.899 164.69 49.865 172 62.117 183.79 79.829 165.72 72.589 158.62" />
            </svg>
            <span class="restroomOvr">QC - Alerts</span>
            <div class="triangle-left"></div>
          </a>
        </li>
      }

      @if (TraxPermission.QC_WORKORDER | canAccess: userPermissions) {
        <li class="treeview" (click)="navSlide()">
          <a (click)="navigationClick('qc-workorder')" style="padding: 6px">
            <svg
              class="restroomOvr1"
              enable-background="new 0 0 218.356 218.356"
              version="1.1"
              viewBox="0 0 218.36 218.36"
              xml:space="preserve"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="m142.68 0h-91.73c-16.143 0-29.278 13.135-29.278 29.278v159.8c0 16.143 13.135 29.278 29.278 29.278h116.46c16.143 0 29.275-13.135 29.275-29.278v-128.71l-54.009-60.369zm4.208 27.525 25.179 28.141h-25.179v-28.141zm34.587 161.55c-3e-3 7.754-6.308 14.061-14.061 14.061h-116.46c-7.753 0-14.061-6.307-14.061-14.061v-159.8c0-7.753 6.307-14.061 14.061-14.061h80.722v55.667h49.803v118.19z"
              />
              <rect x="92.758" y="161.8" width="70.879" height="15.217" />
              <rect x="92.758" y="125.45" width="70.879" height="15.217" />
              <rect x="92.758" y="88.957" width="70.879" height="15.217" />
              <polygon points="61.909 96.664 56.899 91.845 49.865 99.152 62.117 110.94 79.829 92.88 72.589 85.776" />
              <polygon points="61.909 133.16 56.899 128.34 49.865 135.65 62.117 147.44 79.829 129.38 72.589 122.27" />
              <polygon points="61.909 169.51 56.899 164.69 49.865 172 62.117 183.79 79.829 165.72 72.589 158.62" />
            </svg>
            <span class="restroomOvr">QC - Work Orders</span>
            <div class="triangle-left"></div>
          </a>
        </li>
      }

      @if (
        (TraxPermission.ALERT_TEMPLATE | canAccess: userPermissions) ||
        (TraxPermission.VENUE_INVENTORY_CONFIGURATION | canAccess: userPermissions) ||
        (TraxPermission.VENUE_TASK_CONFIGURATION | canAccess: userPermissions) ||
        (TraxPermission.VENUE_ELEMENT_CONFIGURATION | canAccess: userPermissions) ||
        (TraxPermission.VENUE_EVENT_CONFIGURATION | canAccess: userPermissions) ||
        (TraxPermission.VENUE_VIEW | canAccess: userPermissions) ||
        isSysAdmin
      ) {
        <li class="treeview" [routerLinkActive]="['active']">
          <a>
            <i class="fa fa-users fa-2" aria-hidden="true"></i><span>Corp/Venue Mgmt</span>
            <span class="pull-right-container">
              <i class="fa fa-caret-left fa-angle-left"></i>
            </span>
          </a>
          <ul class="treeview-menu corporation-menu">
            @if (TraxPermission.VENUE_VIEW | canAccess: userPermissions) {
              <li [routerLinkActive]="['active']" (click)="navSlide()">
                <a (click)="navigationClick('alert-type-configuration')" [routerLink]="['/alert-type-configuration']">
                  <span><b>&#x25CF;&nbsp;</b> Alert Type Configuration</span>
                  <div class="triangle-left"></div>
                </a>
              </li>
            }
            @if (TraxPermission.ALERT_TEMPLATE | canAccess: userPermissions) {
              <li [routerLinkActive]="['active']" (click)="navSlide()">
                <a (click)="navigationClick('alert-template')" [routerLink]="['/alert-template']">
                  <span><b>&#x25CF;&nbsp;</b> Alert Templates</span>
                  <div class="triangle-left"></div>
                </a>
              </li>
            }
            @if (TraxPermission.VENUE_TASK_CONFIGURATION | canAccess: userPermissions) {
              <li [routerLinkActive]="['active']" (click)="navSlide()">
                <a (click)="navigationClick('venue-task-configuration')" [routerLink]="['/venue-task-configuration']">
                  <span><b>&#x25CF;&nbsp;</b> Tasks</span>
                  <div class="triangle-left"></div>
                </a>
              </li>
            }
            @if (TraxPermission.VENUE_INVENTORY_CONFIGURATION | canAccess: userPermissions) {
              <li [routerLinkActive]="['active']" (click)="navSlide()">
                <a
                  (click)="navigationClick('venue-inventory-configuration')"
                  [routerLink]="['/venue-inventory-configuration']"
                >
                  <span><b>&#x25CF;&nbsp;</b> Inventories</span>
                  <div class="triangle-left"></div>
                </a>
              </li>
            }
            @if (TraxPermission.VENUE_ELEMENT_CONFIGURATION | canAccess: userPermissions) {
              <li [routerLinkActive]="['active']" (click)="navSlide()">
                <a
                  (click)="navigationClick('venue-element-configuration')"
                  [routerLink]="['/venue-element-configuration']"
                >
                  <span><b>&#x25CF;&nbsp;</b> Elements</span>
                  <div class="triangle-left"></div>
                </a>
              </li>
            }
            @if (TraxPermission.VENUE_EVENT_CONFIGURATION | canAccess: userPermissions) {
              <li [routerLinkActive]="['active']" (click)="navSlide()">
                <a
                  (click)="navigationClick('venue-event-configuration')"
                  [routerLink]="['/venue-event-configuration']"
                >
                  <span><b>&#x25CF;&nbsp;</b> Event Configuration</span>
                  <div class="triangle-left"></div>
                </a>
              </li>
            }
          </ul>
        </li>
      }

      @if (
        isSysAdmin ||
        (TraxPermission.SENSORS_VIEW | canAccess: userPermissions) ||
        (TraxPermission.SENSORS_ADD_EDIT | canAccess: userPermissions)
      ) {
        <li class="treeview" [routerLinkActive]="['active']">
          <a>
            <i class="fa fa-podcast" aria-hidden="true"></i><span>Sensor Configuration</span>
            <span class="pull-right-container">
              <i class="fa fa-caret-left fa-angle-left"></i>
            </span>
          </a>
          <ul class="treeview-menu corporation-menu">
            @if (
              (TraxPermission.SENSORS_VIEW | canAccess: userPermissions) ||
              (TraxPermission.SENSORS_ADD_EDIT | canAccess: userPermissions)
            ) {
              <li [routerLinkActive]="['active']" (click)="navSlide()">
                <a (click)="navigationClick('sensor/list')" [routerLink]="['/sensor/list']">
                  <span><b>&#x25CF;&nbsp;</b> Sensors</span>
                  <div class="triangle-left"></div>
                </a>
              </li>
            }
            @if (
              (TraxPermission.SENSORS_VIEW | canAccess: userPermissions) ||
              (TraxPermission.SENSORS_ADD_EDIT | canAccess: userPermissions)
            ) {
              <li [routerLinkActive]="['active']" (click)="navSlide()">
                @if (showSensorSettings) {
                  <a (click)="navigationClick('sensor/settings')" [routerLink]="['/sensor/settings']">
                    <span><b>&#x25CF;&nbsp;</b> Sensor Settings</span>
                    <div class="triangle-left"></div>
                  </a>
                }
              </li>
            }
            @if (isSysAdmin) {
              <li [routerLinkActive]="['active']" (click)="navSlide()">
                <a (click)="navigationClick('sensor/manufacturer')" [routerLink]="['/sensor/manufacturer']">
                  <span><b>&#x25CF;&nbsp;</b> Sensor Manufacturers</span>
                  <div class="triangle-left"></div>
                </a>
              </li>
            }
            @if (isSysAdmin) {
              <li [routerLinkActive]="['active']" (click)="navSlide()">
                <a (click)="navigationClick('sensor/type')" [routerLink]="['/sensor/type']">
                  <span><b>&#x25CF;&nbsp;</b> System Sensor Types</span>
                  <div class="triangle-left"></div>
                </a>
              </li>
            }
          </ul>
        </li>
      }

      @if ((TraxPermission.STATISTICS | canAccess: userPermissions) && isDefaultAlertTypeId) {
        <li class="treeview" (click)="navSlide()">
          <a (click)="navigationClick('statistics')">
            <i class="fa fa-bar-chart" style="font-size: 20px"></i><span>Statistics</span>
            <div class="triangle-left"></div>
          </a>
        </li>
      }

      @if (
        (TraxPermission.TRAX_IQ | canAccess: userPermissions) ||
        (TraxPermission.IQ_DASHBOARD | canAccess: userPermissions) ||
        (TraxPermission.IQ_INSPECTIONS | canAccess: userPermissions) ||
        (TraxPermission.IQ_ALERTS | canAccess: userPermissions) ||
        (TraxPermission.IQ_FEEDBACK | canAccess: userPermissions) ||
        (TraxPermission.IQ_THROUGHPUT | canAccess: userPermissions) ||
        (TraxPermission.IQ_DISPENSERS | canAccess: userPermissions) ||
        (TraxPermission.ROI_LABOUR | canAccess: userPermissions) ||
        (TraxPermission.IQ_RECEPTACLES | canAccess: userPermissions) ||
        (TraxPermission.IQ_STALL_OCCUPANCY | canAccess: userPermissions)
      ) {
        <li id="trax-iq" class="treeview" [routerLinkActive]="['active']">
          <a>
            <i class="fa fa-line-chart" style="font-size: 20px"></i><span>TRAX IQ</span>
            <span class="pull-right-container">
              <i class="fa fa-caret-left fa-angle-left"></i>
            </span>
          </a>
          <ul class="treeview-menu">
            @if (TraxPermission.IQ_DASHBOARD | canAccess: userPermissions) {
              <li [routerLinkActive]="['active']">
                <a (click)="navigationClick('trax-iq/dashboard')" [routerLink]="['/trax-iq/dashboard']">
                  <span><b>&#x25CF;&nbsp;</b>IQ Dashboard</span>
                  <div class="triangle-left"></div>
                </a>
              </li>
            }
            @if (TraxPermission.IQ_INSPECTIONS | canAccess: userPermissions) {
              <li [routerLinkActive]="['active']">
                <a (click)="navigationClick('trax-iq/inspections')" [routerLink]="['/trax-iq/inspections']">
                  <span><b>&#x25CF;&nbsp;</b>Inspections</span>
                  <div class="triangle-left"></div>
                </a>
              </li>
            }
            @if (TraxPermission.IQ_ALERTS | canAccess: userPermissions) {
              <li [routerLinkActive]="['active']">
                <a (click)="navigationClick('trax-iq/service-tickets')" [routerLink]="['/trax-iq/service-tickets']">
                  <span><b>&#x25CF;&nbsp;</b>Alerts</span>
                  <div class="triangle-left"></div>
                </a>
              </li>
            }
            @if ((TraxPermission.IQ_FEEDBACK | canAccess: userPermissions) && isDefaultAlertTypeId) {
              <li [routerLinkActive]="['active']">
                <a (click)="navigationClick('trax-iq/feedback')" [routerLink]="['/trax-iq/feedback']">
                  <span><b>&#x25CF;&nbsp;</b>Feedback</span>
                  <div class="triangle-left"></div>
                </a>
              </li>
            }
            @if ((TraxPermission.IQ_THROUGHPUT | canAccess: userPermissions) && isDefaultAlertTypeId) {
              <li [routerLinkActive]="['active']">
                <a (click)="navigationClick('trax-iq/throughput')" [routerLink]="['/trax-iq/throughput']">
                  <span><b>&#x25CF;&nbsp;</b>Throughput</span>
                  <div class="triangle-left"></div>
                </a>
              </li>
            }
            @if (TraxPermission.ROI_LABOUR | canAccess: userPermissions) {
              <li [routerLinkActive]="['active']">
                <a
                  (click)="navigationClick('trax-iq/Cost_And_Productivity')"
                  [routerLink]="['/trax-iq/Cost_And_Productivity']"
                >
                  <span><b>&#x25CF;&nbsp;</b>Cost & Productivity</span>
                  <div class="triangle-left"></div>
                </a>
              </li>
            }
            @if ((TraxPermission.IQ_DISPENSERS | canAccess: userPermissions) && isDefaultAlertTypeId) {
              <li [routerLinkActive]="['active']">
                <a (click)="navigationClick('trax-iq/dispensers')" [routerLink]="['/trax-iq/dispensers']">
                  <span><b>&#x25CF;&nbsp;</b>Dispensers</span>
                  <div class="triangle-left"></div>
                </a>
              </li>
            }
            @if ((TraxPermission.IQ_RECEPTACLES | canAccess: userPermissions) && isDefaultAlertTypeId) {
              <li [routerLinkActive]="['active']">
                <a (click)="navigationClick('trax-iq/receptacles')" [routerLink]="['/trax-iq/receptacles']">
                  <span><b>&#x25CF;&nbsp;</b>Receptacles</span>
                  <div class="triangle-left"></div>
                </a>
              </li>
            }
            @if ((TraxPermission.IQ_STALL_OCCUPANCY | canAccess: userPermissions) && isDefaultAlertTypeId) {
              <li [routerLinkActive]="['active']">
                <a (click)="navigationClick('trax-iq/StallOccupancy')" [routerLink]="['/trax-iq/StallOccupancy']">
                  <span><b>&#x25CF;&nbsp;</b>Stall Occupancy</span>
                  <div class="triangle-left"></div>
                </a>
              </li>
            }
          </ul>
        </li>
      }

      @if (
        (TraxPermission.THROUGHPUT_CUSTOM_REPORT | canAccess: userPermissions) ||
        (TraxPermission.FEEDBACK_CUSTOM_REPORT | canAccess: userPermissions) ||
        (TraxPermission.DISPENSER_CUSTOM_REPORT | canAccess: userPermissions) ||
        (TraxPermission.TRASH_CUSTOM_REPORT | canAccess: userPermissions) ||
        (TraxPermission.CLEANING_ALERT_CUSTOM_REPORT | canAccess: userPermissions) ||
        (TraxPermission.INVENTORY_CUSTOM_REPORT | canAccess: userPermissions) ||
        (TraxPermission.TASK_CUSTOM_REPORT | canAccess: userPermissions) ||
        (TraxPermission.INSPECTION_LOG_REPORT | canAccess: userPermissions) ||
        (TraxPermission.BADGE_SUMMARY | canAccess: userPermissions) ||
        (TraxPermission.FLUSH_VALVE_CUSTOM_REPORT | canAccess: userPermissions) ||
        (TraxPermission.EQUIPMENT_PM_CUSTOM_REPORT | canAccess: userPermissions) ||
        (TraxPermission.PROJECT_WORK_CUSTOM_REPORT | canAccess: userPermissions) ||
        (TraxPermission.USER_LOG_ACTIVITY_CUSTOM_REPORT | canAccess: userPermissions) ||
        (TraxPermission.CALENDER_SCHEDULES_CUSTOM_REPORT | canAccess: userPermissions) ||
        isSysAdmin
      ) {
        <li class="treeview" [routerLinkActive]="['active']">
          <a>
            <i class="fa fa-file-text-o" aria-hidden="true"></i><span>Reports</span>
            <span class="pull-right-container">
              <i class="fa fa-angle-left pull-right"></i>
            </span>
          </a>
          <ul class="treeview-menu">
            @if ((TraxPermission.THROUGHPUT_CUSTOM_REPORT | canAccess: userPermissions) && isDefaultAlertTypeId) {
              <li [routerLinkActive]="['active']" (click)="navSlide()">
                <a (click)="navigationClick('throughput-custom-report')" [routerLink]="['/throughput-custom-report']">
                  <span><b>&#x25CF;&nbsp;</b>Throughput</span>
                  <div class="triangle-left"></div>
                </a>
              </li>
            }
            @if ((TraxPermission.FEEDBACK_CUSTOM_REPORT | canAccess: userPermissions) && isDefaultAlertTypeId) {
              <li [routerLinkActive]="['active']" (click)="navSlide()">
                <a (click)="navigationClick('feedback-custom-report')" [routerLink]="['/feedback-custom-report']">
                  <span><b>&#x25CF;&nbsp;</b>Feedback</span>
                  <div class="triangle-left"></div>
                </a>
              </li>
            }
            @if ((TraxPermission.DISPENSER_CUSTOM_REPORT | canAccess: userPermissions) && isDefaultAlertTypeId) {
              <li [routerLinkActive]="['active']" (click)="navSlide()">
                <a (click)="navigationClick('dispenser-custom-report')" [routerLink]="['/dispenser-custom-report']">
                  <span><b>&#x25CF;&nbsp;</b>Dispenser</span>
                  <div class="triangle-left"></div>
                </a>
              </li>
            }
            @if ((TraxPermission.TRASH_CUSTOM_REPORT | canAccess: userPermissions) && isDefaultAlertTypeId) {
              <li [routerLinkActive]="['active']" (click)="navSlide()">
                <a (click)="navigationClick('trash-custom-report')" [routerLink]="['/trash-custom-report']">
                  <span><b>&#x25CF;&nbsp;</b>Trash</span>
                  <div class="triangle-left"></div>
                </a>
              </li>
            }
            @if (TraxPermission.CLEANING_ALERT_CUSTOM_REPORT | canAccess: userPermissions) {
              <li [routerLinkActive]="['active']" (click)="navSlide()">
                <a
                  (click)="navigationClick('cleaning-alert-custom-report')"
                  [routerLink]="['/cleaning-alert-custom-report']"
                >
                  <span><b>&#x25CF;&nbsp;</b>Alerts</span>
                  <div class="triangle-left"></div>
                </a>
              </li>
            }
            @if (TraxPermission.INVENTORY_CUSTOM_REPORT | canAccess: userPermissions) {
              <li [routerLinkActive]="['active']" (click)="navSlide()">
                <a (click)="navigationClick('inventory-custom-report')" [routerLink]="['/inventory-custom-report']">
                  <span><b>&#x25CF;&nbsp;</b>Inventory</span>
                  <div class="triangle-left"></div>
                </a>
              </li>
            }
            @if (TraxPermission.TASK_CUSTOM_REPORT | canAccess: userPermissions) {
              <li [routerLinkActive]="['active']" (click)="navSlide()">
                <a (click)="navigationClick('task-custom-report')" [routerLink]="['/task-custom-report']">
                  <span><b>&#x25CF;&nbsp;</b>Task</span>
                  <div class="triangle-left"></div>
                </a>
              </li>
            }
            @if (TraxPermission.INSPECTION_LOG_REPORT | canAccess: userPermissions) {
              <li [routerLinkActive]="['active']" (click)="navSlide()">
                <a (click)="navigationClick('inspection-log-report')" [routerLink]="['/inspection-log-report']">
                  <span><b>&#x25CF;&nbsp;</b>Inspection Summary</span>
                  <div class="triangle-left"></div>
                </a>
              </li>
            }
            @if (TraxPermission.BADGE_SUMMARY | canAccess: userPermissions) {
              <li [routerLinkActive]="['active']" (click)="navSlide()">
                <a (click)="navigationClick('badge-summary')" [routerLink]="['/badge-summary']">
                  <span><b>&#x25CF;&nbsp;</b>Badge Summary</span>
                  <div class="triangle-left"></div>
                </a>
              </li>
            }
            @if ((TraxPermission.FLUSH_VALVE_CUSTOM_REPORT | canAccess: userPermissions) && isDefaultAlertTypeId) {
              <li [routerLinkActive]="['active']" (click)="navSlide()">
                <a (click)="navigationClick('flush-valve-custom-report')" [routerLink]="['/flush-valve-custom-report']">
                  <span><b>&#x25CF;&nbsp;</b>Flush Valve</span>
                  <div class="triangle-left"></div>
                </a>
              </li>
            }
            @if (TraxPermission.EQUIPMENT_PM_CUSTOM_REPORT | canAccess: userPermissions) {
              <li [routerLinkActive]="['active']" (click)="navSlide()">
                <a
                  (click)="navigationClick('equipment-pm-custom-report')"
                  [routerLink]="['/equipment-pm-custom-report']"
                >
                  <span><b>&#x25CF;&nbsp;</b>Equipment PM</span>
                  <div class="triangle-left"></div>
                </a>
              </li>
            }
            @if (TraxPermission.PROJECT_WORK_CUSTOM_REPORT | canAccess: userPermissions) {
              <li [routerLinkActive]="['active']" (click)="navSlide()">
                <a
                  (click)="navigationClick('project-work-custom-report')"
                  [routerLink]="['/project-work-custom-report']"
                >
                  <span><b>&#x25CF;&nbsp;</b> Project Work</span>
                  <div class="triangle-left"></div>
                </a>
              </li>
            }
            @if (TraxPermission.USER_LOG_ACTIVITY_CUSTOM_REPORT | canAccess: userPermissions) {
              <li [routerLinkActive]="['active']" (click)="navSlide()">
                <a
                  (click)="navigationClick('user-log-activity-custom-report')"
                  [routerLink]="['/user-log-activity-custom-report']"
                >
                  <span><b>&#x25CF;&nbsp;</b>User Login Logout Activity</span>
                  <div class="triangle-left"></div>
                </a>
              </li>
            }
            @if (TraxPermission.USER_VIEW | canAccess: userPermissions) {
              <li [routerLinkActive]="['active']" (click)="navSlide()">
                <a
                  (click)="navigationClick('user-billing-custom-report')"
                  [routerLink]="['/user-billing-custom-report']"
                >
                  <span><b>&#x25CF;&nbsp;</b> Users</span>
                  <div class="triangle-left"></div>
                </a>
              </li>
            }
            @if (TraxPermission.CALENDER_SCHEDULES_CUSTOM_REPORT | canAccess: userPermissions) {
              <li [routerLinkActive]="['active']" (click)="navSlide()">
                <a
                  (click)="navigationClick('calender-schedules-custom-report')"
                  [routerLink]="['/calender-schedules-custom-report']"
                >
                  <span><b>&#x25CF;&nbsp;</b> Calendar Schedule</span>
                  <div class="triangle-left"></div>
                </a>
              </li>
            }
          </ul>
        </li>
      }

      @if (TraxPermission.PREDICTIVE_ANALYTICS | canAccess: userPermissions) {
        <li class="treeview AL-Blue">
          <a (click)="navigationClick('predictive-analytics')" style="padding: 4px; display: none">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 405.93 449" class="svgAL-blue">
              <g id="Layer_2" data-name="Layer 2">
                <g id="AI_1_svg">
                  <path
                    d="M192.43,391.5c-156,13-136-124-136-124-1.68,7.58-116.83-95.42,3-161-2-41,22-120,139-75"
                    fill="none"
                    stroke="#000"
                    stroke-miterlimit="10"
                    stroke-width="10"
                  />
                  <path
                    d="M59.93,105c-.28,7.08,55.49-34.22,75,18"
                    fill="none"
                    stroke="#000"
                    stroke-miterlimit="10"
                    stroke-width="10"
                  />
                  <path
                    d="M192.43,391.5c-156,13-136-124-136-124-1.68,7.58-116.83-95.42,3-161-2-41,22-120,139-75"
                    fill="none"
                    stroke="#000"
                    stroke-miterlimit="10"
                    stroke-width="10"
                  />
                  <path
                    d="M59.93,105c-.28,7.08,55.49-34.22,75,18"
                    fill="none"
                    stroke="#000"
                    stroke-miterlimit="10"
                    stroke-width="10"
                  />
                  <path d="M66.93,265s14-52,88-42" fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="10" />
                  <path d="M116.93,77s-7-27,39-35" fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="10" />
                  <path
                    d="M121.43,306.85s71.81,3.2,79.5,91.15V27"
                    fill="none"
                    stroke="#000"
                    stroke-miterlimit="10"
                    stroke-width="10.46"
                  />
                  <path d="M157.93,300s22-35-1-54" fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="10" />
                  <path d="M60.93,127s-22,14,0,42" fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="10" />
                  <polyline
                    points="204.93 92 301.93 91 368.93 119"
                    fill="none"
                    stroke="#000"
                    stroke-miterlimit="10"
                    stroke-width="10"
                  />
                  <polyline
                    points="200.93 54 269.93 54 327.93 27"
                    fill="none"
                    stroke="#000"
                    stroke-miterlimit="10"
                    stroke-width="10"
                  />
                  <polyline
                    points="204.93 231.5 285.93 231.5 347.93 182.5"
                    fill="none"
                    stroke="#000"
                    stroke-miterlimit="10"
                    stroke-width="10.83"
                  />
                  <polyline
                    points="205.93 353 323.93 354 360.93 417"
                    fill="none"
                    stroke="#000"
                    stroke-miterlimit="10"
                    stroke-width="10"
                  />
                  <polyline
                    points="227.41 232.01 269.37 232.01 311.43 289.5"
                    fill="none"
                    stroke="#000"
                    stroke-miterlimit="10"
                    stroke-width="10.83"
                  />
                  <circle
                    cx="344.43"
                    cy="21.5"
                    r="18"
                    fill="none"
                    stroke="#000"
                    stroke-miterlimit="10"
                    stroke-width="7"
                  />
                  <circle
                    cx="384.43"
                    cy="123.5"
                    r="18"
                    fill="none"
                    stroke="#000"
                    stroke-miterlimit="10"
                    stroke-width="7"
                  />
                  <circle
                    cx="360.43"
                    cy="171.5"
                    r="18"
                    fill="none"
                    stroke="#000"
                    stroke-miterlimit="10"
                    stroke-width="7"
                  />
                  <circle
                    cx="322.43"
                    cy="298.5"
                    r="18"
                    fill="none"
                    stroke="#000"
                    stroke-miterlimit="10"
                    stroke-width="7"
                  />
                  <circle
                    cx="366.43"
                    cy="427.5"
                    r="18"
                    fill="none"
                    stroke="#000"
                    stroke-miterlimit="10"
                    stroke-width="7"
                  />
                </g>
              </g>
            </svg>
            <span class="predictive-heading">Predictive Analytics</span>
            <div class="triangle-left"></div>
          </a>
        </li>
      }

      @if (TraxPermission.IMPORT_DATA | canAccess: userPermissions) {
        <li class="treeview" [routerLinkActive]="['active']" (click)="navSlide()">
          <a (click)="navigationClick('import-data')">
            <i class="fa fa-upload"></i><span>Import Data</span>
            <div class="triangle-left"></div>
          </a>
        </li>
      }
      <li class="version-nav">V. {{ appVersion }} ({{ apiVersion | async }})</li>
    </ul>
  </section>
</aside>

<div
  class="modal"
  id="LogoutConfirmationModal"
  [ngStyle]="LogoutConfirmationModal ? { display: 'block' } : { display: 'none' }"
>
  <div class="modal-dialog modal-sm">
    <div class="modal-content">
      <div class="modal-header">
        <h3 class="modal-title">Sign Out</h3>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          (click)="CloseLogoutConfirmationModal()"
          style="margin-top: -37px"
        >
          &times;
        </button>
      </div>

      <div class="modal-body">
        <div class="row">
          <div class="col-lg-12 col-md-12 col-sm-12">
            <h4>Are you sure you want to Sign Out?</h4>
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <div class="col-lg-12 col-md-12 col-xs-12 btn-footer">
          <button class="btn btn-type btn-save" (click)="signOut()">Yes</button>
          <button class="btn btn-type btn-cancel" data-dismiss="modal" (click)="CloseLogoutConfirmationModal()">
            No
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
